import React, { useState } from "react";

import EndSalesModal from "components/EndSalesModal";

// `options` lets a non-ticket surface (e.g. the Merch tab) reuse the modal with an
// explicit item list and its own copy: { items, titlePrefix, itemNoun }.
const useEndSalesController = (event, TicketResource, ticketResourceParams, options = {}) => {

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const EndSalesModalComponent = () => {
    return (
      <EndSalesModal
        event={event}
        TicketResource={TicketResource}
        ticketResourceParams={ticketResourceParams}
        open={open}
        onOpenChange={setOpen}
        {...options}
      />
    );
  };

  return {
    openEndSalesModal: open,
    handleEndSalesModalOpen: handleOpen,
    EndSalesModalComponent,
  };
};

export default useEndSalesController;
